module.exports = __webpack_public_path__ + "static/media/ios-footer.0c3384f8.png";